import { render, staticRenderFns } from "./CardAsistencia.vue?vue&type=template&id=65aa38bb&scoped=true&"
import script from "./CardAsistencia.vue?vue&type=script&lang=js&"
export * from "./CardAsistencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa38bb",
  null
  
)

export default component.exports